import React from 'react';
import {LanguageContext} from "../App";

class SearchBar extends React.Component {
    constructor(props) {
        super(props);

        this.setValue = e => {
            this.props.getSearchValue(e.target.value)
        };
        this.clearInput = () => {
            document.getElementById('searchInput').value = '';
            this.props.getSearchValue('')
        };
    }

    render() {
        return (
            <LanguageContext.Consumer>
                {({ language }) =>
                    <div style={{'position': 'relative'}}>
                        <input id="searchInput" type="text" onKeyUp={this.setValue} placeholder={language['wyszukaj_puzzle']}/>
                        <button style={{'display': this.props.searchValue === '' ? 'none' : ''}} id="searchClear"
                                onClick={this.clearInput}>
                            <i className="fa fa-times-circle"/>
                        </button>
                    </div>
                }
            </LanguageContext.Consumer>

        )
    }
}

export default SearchBar


// WEBPACK FOOTER //
// ./src/LeftMenu/SearchBar.js